const bonding = {
  hero: {
    badge: "Αισθητική Οδοντιατρική",
    title: "Οδοντικές Όψεις Ρητίνης",
    description:
      "Μεταμορφώστε το χαμόγελό σας με τις εξειδικευμένες υπηρεσίες οδοντικής όψης που προσφέρουμε. Χρησιμοποιώντας προηγμένες τεχνικές.Η ρητίνη στο χρώμα των δοντιών, αποκαθιστούμε σπασμένα, αποχρωματισμένα ή παραμορφωμένα δόντια, προσφέροντας ένα φυσικό και αρμονικό αποτέλεσμα που ενισχύει την εμφάνισή σας και την αυτοπεποίθησή σας.",
    ctas: {
      primary: "Κλείστε Ραντεβού",
      secondary: "Μάθετε Περισσότερα για τη Διαδικασία",
    },
    stats: {
      value1: "97%",
      value2: "4.9",
      title: "97% Ικανοποίηση Ασθενών",
      subtitle: "Βαθμολογία 4.9 / 5 Βάσει Κριτικών Ασθενών",
    },
    imageAlt: "Διαδικασία οδοντικής όψης ρητίνης",
  },
  benefits: {
    heading: "Οφέλη των Οδοντικών Όψεων",
    intro:
      "Ανακαλύψτε γιατί οι ασθενείς επιλέγουν των οδοντικών όψεων για να μεταμορφώσουν το χαμόγελό τους",
    items: [
      {
        title: "Διαδικασία Μίας Επίσκεψης",
        description:
          "Ολοκληρώστε τη συγκόλληση σε μία μόνο επίσκεψη, εξοικονομώντας χρόνο χωρίς συμβιβασμούς στην ποιότητα.",
      },
      {
        title: "Ελάχιστα Επεμβατική",
        description:
          "Διατηρεί περισσότερη φυσική οδοντική δομή χάρη στην πιο συντηρητική αισθητική προσέγγιση.",
      },
      {
        title: "Βελτιωμένη Εμφάνιση",
        description:
          "Ανανεώστε το χαμόγελό σας διορθώνοντας σπασμένα δόντια, γεμίζοντας κενά και ταιριάζοντας το χρώμα με τα φυσικά δόντια.",
      },
      {
        title: "Φυσικά Αποτελέσματα",
        description:
          "Η άριστη χρωματική ταύτιση της ρητίνης εξασφαλίζει αόρατες, αρμονικές αποκαταστάσεις.",
      },
      {
        title: "Άμεση Αυτοπεποίθηση",
        description:
          "Φύγετε από το ιατρείο με ένα άμεσα βελτιωμένο χαμόγελο που ενισχύει την αυτοπεποίθηση σας.",
      },
      {
        title: "Πολύπλευρη Λύση",
        description:
          "Αντιμετωπίστε πολλαπλά αισθητικά ζητήματα με μία ευέλικτη θεραπεία που προσαρμόζεται στις ανάγκες σας.",
      },
    ],
    bottomLinePrefix: "Θέλετε να μάθετε αν η οδοντική όψη είναι κατάλληλη για εσάς;",
    bottomLineCta: "Κλείστε ένα ραντεβού σήμερα",
  },
  process: {
    heading: "Η Διαδικασία της Οδοντικής Όψης (Bonding)",
    intro: "Η λεπτομερής προσέγγισή μας εξασφαλίζει όμορφα και φυσικά αποτελέσματα",
    steps: [
      {
        number: "01",
        title: "Εξέταση & Αξιολόγηση",
        description:
          "Ο οδοντίατρος θα εξετάσει τα δόντια σας, θα συζητήσει και θα καθορίσει αν η οδοντική όψη είναι κατάλληλη για εσάς.",
      },
      {
        number: "02",
        title: "Σχεδιασμός Θεραπείας",
        description:
          "Θα επιλέξουμε την κατάλληλη απόχρωση ρητίνης που ταιριάζει με τα φυσικά σας δόντια και θα σχεδιάσουμε τη διαδικασία για βέλτιστα αποτελέσματα.",
      },
      {
        number: "03",
        title: "Προετοιμασία Δοντιού",
        description:
          "Η επιφάνεια του δοντιού λειαίνεται απαλά και εφαρμόζεται ένα ειδικό υγρό για να βοηθήσει στην πρόσφυση της ρητίνης.",
      },
      {
        number: "04",
        title: "Εφαρμογή Όψης",
        description:
          "Η ρητίνη στο χρώμα του δοντιού εφαρμόζεται, διαμορφώνεται στο επιθυμητό σχήμα και σκληραίνει με ειδικό φως.",
      },
      {
        number: "05",
        title: "Τελειοποίηση",
        description:
          "Το υλικό κόβεται, διαμορφώνεται και γυαλίζεται για να ταιριάζει με τα φυσικά σας δόντια και να εξασφαλίζει άνετο δάγκωμα.",
      },
    ],
    expected: {
      heading: "Αναμενόμενα Αποτελέσματα",
      left: [
        "Φυσικής όψης αποκατάσταση σπασμένων, ραγισμένων ή αποχρωματισμένων δοντιών",
        "Κλείσιμο μικρών κενών μεταξύ των δοντιών",
        "Βελτίωση της εμφάνισης δοντιών με ακανόνιστο σχήμα",
      ],
      right: [
        "Προστασία εκτεθειμένων ριζών λόγω υποχώρησης των ούλων",
        "Άμεσα αποτελέσματα σε μόλις ένα ραντεβού",
        "Ενίσχυση της εμφάνισης του χαμόγελου και της αυτοπεποίθησης",
      ],
    },
  },
  faq: {
    heading: "Συχνές Ερωτήσεις",
    intro: "Όλα όσα χρειάζεται να ξέρετε για την οδοντική συγκόλληση",
    items: [
      {
        question: "Πόσο διαρκεί η επαναδιαμόρφωση δοντιού;",
        answer:
          "Η οδοντική αναδιαμόρφωση διαρκεί συνήθως από 3 έως 10 χρόνια, ανάλογα με τη θέση της, τις στοματικές σας συνήθειες και τη φροντίδα των δοντιών σας. Οι τακτικοί οδοντιατρικοί έλεγχοι και η σωστή στοματική υγιεινή συμβάλλουν στη μακροχρόνια διατήρησή της.",
      },
      {
        question: "Είναι επώδυνη η διαδικασία της επαναδιαμόρφωση;",
        answer:
          "Όχι, η διαδικασία είναι συνήθως ανώδυνη. Στις περισσότερες περιπτώσεις, δεν απαιτείται καν αναισθησία, εκτός αν η συγκόλληση γίνεται για να καλυφθεί τερηδόνα, απαιτείται τρόχισμα του δοντιού ή η ζημιά είναι κοντά στο νεύρο.",
      },
      {
        question: "Πόσο κοστίζει η οδοντική επαναδιαμόρφωση;",
        answer:
          "Το κόστος διαφέρει ανάλογα με την έκταση της θεραπείας, τον αριθμό των δοντιών που απαιτούν θεραπεία και την τοποθεσία του ιατρείου. Είναι γενικά από τις πιο οικονομικές αισθητικές οδοντιατρικές λύσεις. Σας παρέχουμε αναλυτική εκτίμηση κόστους κατά τη διάρκεια της συμβουλευτικής επίσκεψης.",
      },
      {
        question: "Πόσο διαρκεί η διαδικασία;",
        answer:
          "Η οδοντική συγκόλληση διαρκεί περίπου 30 έως 60 λεπτά ανά δόντι. Συνήθως ολοκληρώνεται σε μία μόνο επίσκεψη, καθιστώντας την ιδανική για ασθενείς με περιορισμένο χρόνο.",
      },
      {
        question: "Πώς φροντίζω τα δόντια μου;",
        answer:
          "Φροντίστε τα συγκολλημένα δόντια όπως τα φυσικά σας δόντια: καθημερινό βούρτσισμα, οδοντικό νήμα και τακτικοί οδοντιατρικοί έλεγχοι. Αποφύγετε να δαγκώνετε σκληρά αντικείμενα όπως πάγο, στυλό ή νύχια και περιορίστε τις χρωστικές τροφές και ποτά όπως καφές, τσάι και καπνός.",
      },
      {
        question: "Μπορεί η θεραπεία να διορθώσει όλα τα οδοντικά προβλήματα;",
        answer:
          "Η οδοντική επαναδιαμόρφωση είναι ευέλικτη αλλά δεν είναι κατάλληλη για κάθε περίπτωση. Ενδείκνυται για μικρές αισθητικές βελτιώσεις, μικρά σπασίματα, κενά ή αποχρωματισμούς. Για πιο εκτεταμένες βλάβες ή για δόντια που δέχονται έντονες μασητικές πιέσεις, μπορεί να είναι πιο κατάλληλες άλλες λύσεις, όπως όψεις ή στεφάνες.",
      },
      {
        question: "Είναι αναστρέψιμη η οδοντική επαναδιαμόρφωση;",
        answer:
          "Ναι, συνήθως είναι αναστρέψιμη, αφού δεν αφαιρείται σημαντική ποσότητα από την αρχική αδαμαντίνη. Αν στο μέλλον θελήσετε να δοκιμάσετε κάποια άλλη αισθητική λύση, η ρητίνη μπορεί να αφαιρεθεί χωρίς να προκληθεί μόνιμη βλάβη στο φυσικό δόντι.",
      },
    ],
    bottomLine: "Έχετε ακόμα απορίες για την οδοντική επαναδιαμόρφωση;",
    cta: "Επικοινωνήστε μαζί μας",
  },
};

export default bonding;

